<iframe *ngIf="iframeUri" class="iframe" [src]="iframeUri.webAppUri! | safe" [title]="iframeUri.name || 'Vendor Service Application'"></iframe>
